import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display"]

  connect() {
    this.updateDisplay()
  }

  handleChange() {
    this.updateDisplay()
  }

  updateDisplay() {
    const files = this.inputTarget.files
    const fileNames = Array.from(files).map(file => file.name)
    const placeholder = this.displayTarget.dataset.placeholder || ""
    
    if (fileNames.length > 0) {
      this.displayTarget.textContent = fileNames.join(", ")
      this.displayTarget.classList.remove("hidden")
    } else if (placeholder) {
      this.displayTarget.textContent = placeholder
      this.displayTarget.classList.remove("hidden")
    } else {
      this.displayTarget.classList.add("hidden")
    }
  }
}